import React from 'react';
import { Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import EditIcon from '@/assets/icons/edit-icon.svg?react';
import { usePopoverContext } from '@/components/global/buttons/CustomMorePopover';

const CustomEditModalButton = ({ onOpen, label, disabled = false }) => {
    const { closePopover } = usePopoverContext();
    const translate = useTranslate();
    const buttonLabel = label || translate('common.edit');

    return (
        <Button
            onClick={event => {
                event.stopPropagation();
                onOpen();
                closePopover();
            }}
            disabled={disabled}
            aria-label={buttonLabel}
        >
            <EditIcon /> {buttonLabel}
        </Button>
    );
};

export default CustomEditModalButton;
